import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, get, put, updateCSRFToken, del } from "helpers/api_helper";
import { decrypt, getValuesSocketData } from "helpers/secretManager";
import * as URL from "helpers/url_helper";
import { toast } from "react-toastify";


// Role 

export const roleListApi = createAsyncThunk(
    "roleListApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await post(URL.GET_ROLE_LIST, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const addRoleApi = createAsyncThunk(
    "addRoleApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await post(URL.ADD_ROLE, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            toast.success(response?.message);
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const updateRoleApi = createAsyncThunk(
    "updateRoleApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await put(URL.EDIT_ROLE + data?._id, data, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            toast.success(response?.message);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const statusChangeRoleApi = createAsyncThunk(
    "statusChangeRoleApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await put(URL.STATUS_ROLE + data?._id, data, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            toast.success(response?.message);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const deleteRole = createAsyncThunk(
    "deleteRole",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await del(URL.DELETE_ROLE + data?._id, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const roleDetailsApi = createAsyncThunk(
    "roleDetailsApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();
            let response = await get(URL.DETAILS_ROLE + "/" + data?._id,
                {
                    signature,
                    nonce
                });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const getActivePermissionList = createAsyncThunk(
    "getActivePermissionList",
    async (arg = {}, Thunk) => {
        const { callBack, data } = arg; 
        try {
            const { signature, nonce } = await getValuesSocketData();
            let response = await get(URL.GET_ACTIVE_PERMISSION_LIST, {
                signature,
                nonce,
                params: { ...data }
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

// Permission
export const addPermissionApi = createAsyncThunk(
    "addPermissionApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await post(URL.ADD_PERMISSION, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            toast.success(response?.message);
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const permissionListApi = createAsyncThunk(
    "permissionListApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await post(URL.GET_PERMISSION_LIST, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const updatePermissionApi = createAsyncThunk(
    "updatePermissionApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await put(URL.EDIT_PERMISSION + data?._id, data, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            toast.success(response?.message);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);


// Permission Meta 

export const permissionMetaApi = createAsyncThunk(
    "permissionMetaApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await post(URL.GET_PERMISSION_META, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const addPermissionMetaApi = createAsyncThunk(
    "addPermissionMetaApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await post(URL.ADD_PERMISSION_META, data, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            toast.success(response?.message);
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const updatePermissionMetaApi = createAsyncThunk(
    "updatePermissionMetaApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await put(URL.EDIT_PERMISSION_META + data?._id, data, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            toast.success(response?.message);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const deletePermissionMetaRole = createAsyncThunk(
    "deletePermissionMetaRole",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await del(URL.DELETE_PERMISSION_META + data?._id, {
                signature,
                nonce,
            });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const permissionMetaDetailsApi = createAsyncThunk(
    "permissionMetaDetailsApi",
    async ({ data, callBack }, Thunk) => {
        try {
            const { signature, nonce } = await getValuesSocketData();
            let response = await get(URL.DETAILS_PERMISSION_META + "/" + data?._id,
                {
                    signature,
                    nonce
                });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);

export const permissionMetaActiveListApi = createAsyncThunk(
    "permissionMetaActiveListApi",
    async (arg = {}, Thunk) => {
        const { callBack } = arg;
        try {
            const { signature, nonce } = await getValuesSocketData();

            let response = await get(URL.GET_ACTIVE_PERMISSION_META, { signature, nonce });
            if (response.status === "failure") {
                toast.error(response?.message);
                return Thunk.rejectWithValue(response?.message);
            }
            callBack && callBack(null, response);
            return response;
        } catch (error) {
            console.error(error, "<===error");
            toast.error(error?.message || "Something went wrong!");
            callBack && callBack(error?.message || "Something went wrong!");

            return Thunk.rejectWithValue(error);
        }
    },
);
